import { computed, ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17ab85fb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "elli-multiple-2"
};
const _hoisted_3 = {
  class: "elli-multiple-1"
};
const _hoisted_4 = {
  class: "elli-multiple-2"
};
const _hoisted_5 = {
  key: 3,
  class: "status-content"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0,
  class: "handle-content"
};
import { useStore } from '@/store';
import { awaitWrap, OK, reportEvent } from '@/common';
import PropsAddModal from '@/views/propsGivenAway/components/PropsAddModal.vue';
import { queryGivenList } from '@/api/givenGift';
export default /*#__PURE__*/_defineComponent({
  __name: 'PropsTableBlock',
  setup(__props, {
    expose
  }) {
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const columns = [{
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId',
      width: 200
    }, {
      title: '赠送商品',
      dataIndex: 'prodId',
      key: 'prodId',
      width: 200
    },
    // { title: '商品价格', dataIndex: 'price', key: 'price', width: 120 },
    {
      title: '赠送数量',
      dataIndex: 'prodNum',
      key: 'prodNum',
      width: 120
    }, {
      title: '赠送时间',
      dataIndex: 'updateTime',
      key: 'updateTime'
    }, {
      title: '赠送理由',
      dataIndex: 'giftReason',
      key: 'giftReason'
    }, {
      title: '操作人',
      dataIndex: 'createUser',
      key: 'createUser',
      width: 160
    }, {
      title: '赠送状态',
      dataIndex: 'giftStatus',
      key: 'giftStatus',
      width: 120
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const giftStatusList = [{
      label: '成功',
      value: 10
    }, {
      label: '失败',
      value: 20
    }, {
      label: '赠送中',
      value: 0
    }];
    const dataSource = ref([]); // 表格数据
    const pageIndex = ref(1); // 当前页
    const pageSize = ref(20); // 每页条数
    const pageTotal = ref(0); // 总条数
    const searchObj = ref({}); // 搜索条件
    const tableRef = ref(); // 表格ref
    const editItem = ref({}); // 详情数据
    const addModalVisible = ref(false); // 新增弹窗
    const tableLoading = ref(false); // 表格loading
    const getData = async () => {
      const startTime = new Date().getTime();
      let params = {
        pageNum: pageIndex.value,
        pageSize: pageSize.value
      };
      Object.keys(searchObj.value).forEach(item => {
        if (searchObj.value[item] || searchObj.value[item] === 0) {
          params = {
            ...params,
            [item]: searchObj.value[item]
          };
        }
      });
      // dataSource.value = []
      tableLoading.value = true;
      const [err, data] = await awaitWrap(queryGivenList(params));
      if (data) {
        if ((data === null || data === void 0 ? void 0 : data.code) === OK) {
          var _data$data, _data$data2;
          dataSource.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.list;
          pageTotal.value = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.total;
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '道具赠送',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'succeed'
            }
          });
        } else {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '道具赠送',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      }
      if (err) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '道具赠送',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
      tableLoading.value = false;
    }; // 获取表格数据
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      await getData();
    }; // 搜索
    const changePage = async (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      await getData();
    }; // 分页
    const retryGiven = item => {
      editItem.value = item;
      addModalVisible.value = true;
    }; // 重试赠送
    const addProps = () => {
      addModalVisible.value = true;
    }; // 新增赠送
    const resetEdit = () => {
      editItem.value = {};
    }; // 重置编辑数据
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        onClick: addProps,
        class: "add-btn",
        type: "primary"
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "add"
        })]),
        default: _withCtx(() => [_createTextVNode(" 赠送道具 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'givenGift',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]])]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        loading: tableLoading.value
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _giftStatusList$find2, _unref3;
          return [column.dataIndex === 'deviceId' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.deviceId), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(record.deviceId), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'giftReason' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.giftReason), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(record.giftReason), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'prodId' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 2,
            placement: "topLeft"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.prodId), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(record.prodId), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'giftStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
            class: _normalizeClass(["circle", {
              blue: record.giftStatus === 0,
              green: record.giftStatus === 10,
              red: record.giftStatus === 20
            }])
          }, null, 2), record.giftStatus === 20 ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(record.resMsg), 1)]),
            default: _withCtx(() => {
              var _giftStatusList$find;
              return [_createElementVNode("span", {
                class: _normalizeClass({
                  red: record.giftStatus === 20
                })
              }, _toDisplayString((_giftStatusList$find = giftStatusList.find(item => item.value === record.giftStatus)) === null || _giftStatusList$find === void 0 ? void 0 : _giftStatusList$find.label), 3)];
            }),
            _: 2
          }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString((_giftStatusList$find2 = giftStatusList.find(item => item.value === record.giftStatus)) === null || _giftStatusList$find2 === void 0 ? void 0 : _giftStatusList$find2.label), 1))])) : _createCommentVNode("", true), column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 4
          }, [record.giftStatus === 20 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => retryGiven(record)
          }, {
            default: _withCtx(() => [_createTextVNode("重试")]),
            _: 2
          }, 1032, ["onClick"])])), [[_directive_permission, {
            permissionValue: 'givenGift',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source", "loading"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(PropsAddModal, {
        "modal-visible": addModalVisible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => addModalVisible.value = $event),
        "dbt-id": searchObj.value.dbtId,
        "edit-item": editItem.value,
        onResetEdit: resetEdit,
        onUpdateList: getData
      }, null, 8, ["modal-visible", "dbt-id", "edit-item"])]);
    };
  }
});